export class ResponseFaseEstrategicaModel{
    payload:FaseEstrategicaModel;

    constructor(){
        this.payload = new FaseEstrategicaModel();
    }
}

export class FaseEstrategicaModel{    
    idJardin:number;
    idJardinPeriodo:number;
    idTipoJardin:number;
    idFaseEstrategica:number;
    estadoFase:number;
    areas:AreasModel[];
    rbd:string;
    tipoJardin:string;
    jardin:string;
    objetivosEstrategicos:string;
    constructor(){
        this.idJardin = -1;
        this.idJardinPeriodo = -1;
        this.idTipoJardin = -1;
        this.idFaseEstrategica = -1;
        this.estadoFase = -1;
        this.areas = new Array<AreasModel>();
        this.rbd = "";
        this.tipoJardin = "";
        this.jardin = "";
        this.objetivosEstrategicos = "";
    }
}

export class AreasModel{    

    area:string;
    idArea:number; 
    orden:number;
    subdimensiones:SubdimensionModel[];
    constructor(){
        this.area = "";
        this.idArea = -1;
        this.orden = -1;
        this.subdimensiones = new Array<SubdimensionModel>();
    }
}
export class SubdimensionModel{    

    idSubdimension:number;
    subdimension:string;
    numSubdimension:number;
    objetivosAreas:ObjetivosAreaJardinModel[];
    constructor(){
        this.subdimension = "";
        this.idSubdimension = -1;
        this.numSubdimension = -1;
        this.objetivosAreas = new Array<ObjetivosAreaJardinModel>();
    }
}

export class ObjetivosAreaJardinModel {    

    idFaseEstrategicaPlanMejora:number;
    objetivoTexto:string; 
    idObjetivo:number;
    idMeta:number;
    meta:string;
    idEstrategia1:number;
    estrategia1:string;
    idEstrategia2:number;
    estrategia2:string;
    subdimencion:string;

    constructor(){
        this.idFaseEstrategicaPlanMejora = -1;
        this.objetivoTexto = "";
        this.idObjetivo = -1;
        this.idMeta = -1;
        this.meta = "";
        this.idEstrategia1 = -1;
        this.estrategia1 = "";
        this.idEstrategia2 = -1;
        this.estrategia2 = "";
        this.subdimencion = "";

    }
}
